module.exports = __webpack_public_path__ + "static/media/ug.3e65a83e.webp";